import { call, put, takeEvery } from "redux-saga/effects";
import { FEEDBACK_LIST_WATCHER } from "../../actionTypes/user";
import { updateMenuList } from "../../actionCreators/user/feedBack";
import Service from "../../../services/user/feedBack"
import { updateFalseLoader, updateOpenLoader } from "../../actionCreators/spinner";
import { updateAlert } from "../../actionCreators/alert";
import { errorMessage } from "../../../utils/errorMessage";


function* feedBackListEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(Service.get, action.id, action.payload);

    yield put(updateMenuList(data.recordset));
    yield put(updateFalseLoader());
    //yield put(updateAlert('Success', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(errorMessage(e, 'Something Went Wrong!'), 'error'));
  }
}


//saga 
export const feedBackListSaga = [
  takeEvery(FEEDBACK_LIST_WATCHER, feedBackListEffect),
]